
define('text!modules/targeting/contextual/templates/panel.html',[],function () { return '<div class="w-box w-ContextualTargeting">\n    <div class="view-loader"></div>\n\t<div class="w-body w-panel-body"><!-- The Search & browse views render here--></div>\n\t<div class="w-foot">{{>form_footer}}</div>\n</div>';});

